"use strict";
exports.__esModule = true;
exports.Heading2Size = void 0;
var Heading2Size;
(function (Heading2Size) {
    Heading2Size["large"] = "square";
    Heading2Size["small"] = "rectangle";
})(Heading2Size = exports.Heading2Size || (exports.Heading2Size = {}));
//# sourceMappingURL=sizeable-heading2-slice.js.map